export default {
  label: '财务总监',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '财务总监是企业高层管理职位，负责制定和执行公司的财务战略，参与公司重大决策，确保企业财务健康运行',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '制定并监督执行财务管理、会计核算、预算管理、审计监察等规章制度',
          id: '0-2-1',
        },
        {
          label: '负责公司整体财务规划和策略制定',
          id: '0-2-2',
        },
        {
          label: '审核和评估重要融资项目，控制投资风险',
          id: '0-2-3',
        },
        {
          label: '管理预算与预决算，审查重大收支项目',
          id: '0-2-4',
        },
        {
          label: '向总经理汇报财务状况，提出改进建议',
          id: '0-2-5',
        },
        {
          label: '组织年度财务收支审计和经营成果审计',
          id: '0-2-6',
        },
        {
          label: '协调与银行、税务、财政等机构的关系',
          id: '0-2-7',
        }
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '本科及以上学历，会计或财务管理相关专业',
          id: '0-3-1',
        },
        {
          label: '至少5年以上财务管理经验，其中至少3年高级管理经验',
          id: '0-3-2',
        },
        {
          label: '拥有CPA、ACCA等高级财务资格证书优先',
          id: '0-3-3',
        },
        {
          label: '具备全面的财务管理知识，熟悉现代企业管理知识',
          id: '0-3-4',
        },
        {
          label: '强大的分析判断能力、沟通协调能力和领导能力',
          id: '0-3-5',
        }
      ],
    },
    {
      label: '薪资情况',
      id: '0-4',
      children: [
        {
          label: '25万元',
          id: '0-4-1',
        },
      ],
    }
  ],
};